module.exports = __webpack_public_path__ + "img/instagram.a0c5fc21.png";